(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4682],{

/***/ 95716:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/step-1",
      function () {
        return __webpack_require__(70076);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43692);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46834);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46323);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39771);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _api_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66564);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56168);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22135);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17651);
/* harmony import */ var _helpers_storageHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38869);
/* harmony import */ var _enums_storageKeys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3245);
/* harmony import */ var _context_authContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13102);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var components_Select_Select__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53173);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70082);



// @ts-ignore


















var RegisterStep1 = function(param) {
    var plays = param.plays, countries = param.countries, countryCode = param.countryCode;
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Register */ .l.Register).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_17__/* .useLang */ .J)().locale;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    var user = (0,_context_authContext__WEBPACK_IMPORTED_MODULE_14__/* .useAuth */ .aC)().user;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var serverError = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(countries.map(function(c) {
        return {
            value: c.id,
            label: c.title
        };
    })), countryData = ref2[0];
    var preselectedCountry = (ref = countries.find(function(c) {
        return c.suggested;
    })) === null || ref === void 0 ? void 0 : ref.id;
    (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useFade */ .dH)(ref1, plays);
    var onSubmit = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
            var EMAIL_RULE, NOT_EMPTY_RULE, form, email, fullName, taxCountryId, validateObject, formSchema, valid, emailExists;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        EMAIL_RULE = t("common:form.email_format");
                        NOT_EMPTY_RULE = t("common:form.not_empty");
                        form = event.target;
                        email = form.email.value;
                        fullName = form.fullName.value;
                        taxCountryId = form.taxCountryId.value;
                        validateObject = {
                            email: email,
                            fullName: fullName,
                            taxCountryId: taxCountryId
                        };
                        formSchema = (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .createFormSchema */ .ZS)({
                            email: (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .emailRule */ .$D)(EMAIL_RULE, NOT_EMPTY_RULE),
                            fullName: (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .notEmptyRule */ .ji)(NOT_EMPTY_RULE),
                            taxCountryId: (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .notEmptyRule */ .ji)(NOT_EMPTY_RULE)
                        });
                        valid = (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .validateForm */ .G$)(formSchema, validateObject, formRef.current);
                        if (!valid) {
                            _ctx.next = 19;
                            break;
                        }
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .setLoadingState */ .bG)(formRef.current);
                        _ctx.next = 15;
                        return (0,_api_client__WEBPACK_IMPORTED_MODULE_6__/* .getSharedApiClient */ .L)().checkUserExists(email);
                    case 15:
                        emailExists = _ctx.sent;
                        if (!emailExists.exists) {
                            _helpers_storageHelper__WEBPACK_IMPORTED_MODULE_10__/* ["default"].saveJSON */ .Z.saveJSON(_enums_storageKeys__WEBPACK_IMPORTED_MODULE_11__/* .StorageKeys.REGISTER_DETAILS */ .B.REGISTER_DETAILS, {
                                email: email,
                                fullName: fullName,
                                taxCountryId: taxCountryId
                            });
                            router.push(_helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.registerStep2 */ .xm.registerStep2(locale));
                        } else {
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .resetForm */ .Fx)(formRef.current);
                            serverError.current.innerHTML = t("common:form.already_exists");
                            formRef.current.classList.add("display-server-errors");
                        }
                        _ctx.next = 20;
                        break;
                    case 19:
                        {
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .resetForm */ .Fx)(formRef.current);
                        }
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        formRef
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_15___default()), {
                children: (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .basicSEO */ .Fi)(t("seo:register_step1_title"), t("seo:register_step1_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().register),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().registerWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            ref: ref1,
                            className: [
                                "fade-container",
                                (_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().fadeContainer)
                            ].join(" "),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                className: "swiper-wrapper",
                                children: plays === null || plays === void 0 ? void 0 : plays.map(function(play) {
                                    var ref;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                        className: "swiper-slide fade-slide",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                    src: play.poster_url,
                                                    alt: play.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                children: [
                                                    play.title,
                                                    ((ref = play.theatre) === null || ref === void 0 ? void 0 : ref.name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                        children: [
                                                            " ",
                                                            "/ ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                children: play.theatre.name
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, play.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            i18nKey: (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .getNoTrialTranslationKeyIfNeeded */ .jU)("register:description", countryCode),
                            components: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().description)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("em", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                            ref: formRef,
                            onSubmit: onSubmit,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                    children: [
                                        t("email"),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                            type: "text",
                                            id: "email",
                                            name: "email"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            ref: serverError,
                                            className: "server-error"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                    children: [
                                        t("full_name"),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                            type: "text",
                                            id: "fullName",
                                            name: "fullName"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                    children: [
                                        t("register:country_of_residence"),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Select_Select__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            defaultValue: preselectedCountry,
                                            name: "taxCountryId",
                                            options: countryData,
                                            defaultLabel: t("common:pick_country")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-primary",
                                    children: t("btn_continue")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    i18nKey: "register:register_terms",
                                    components: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().registerTerms)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            href: _helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.termsAndConditions */ .xm.termsAndConditions(locale),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            href: _helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.privacyPolicy */ .xm.privacyPolicy(locale),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {})
                                        }), 
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                            children: [
                                t("already_account"),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    href: _helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.login */ .xm.login(locale),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        children: t("login_prompt")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_context_authContext__WEBPACK_IMPORTED_MODULE_14__/* .redirectWhenAuth */ .oZ)(RegisterStep1));


/***/ }),

/***/ 39771:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"register":"step-1_register__QeO6q","description":"step-1_description__a0OLI","registerWrapper":"step-1_registerWrapper__Roebd","voucher-input":"step-1_voucher-input__gZduz","fadeContainer":"step-1_fadeContainer__QbKGw","password":"step-1_password__OfolQ","registerTerms":"step-1_registerTerms__7SPDk"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(95716); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);